const adminPt = {
  administration: 'Administração',
  addMore: 'Adicionar mais um',
  colors: 'Cores',
  predefinedTheme: 'Temas predefinidos',
  countSelected: '{{count}} Selecionado',
  countSelected_plural: '{{count}} Selecionados',
  createError: 'Não foi possível concluir a operação',
  createSuccess: 'Operação efetuada com sucesso',
  member: '({{count}}) Membro',
  member_plural: '({{count}}) Membros',
  searchMembers: 'Pesquisar membros',
  updateError: 'As alteraçãoes não foram efetuadas',
  updateSuccess: 'As alterações foram efetuadas com sucesso',
  adSyncSettings: {
    adSyncSettings: 'Configurar sincronização AD',
    authType: 'Modo de autenticação',
    domain: 'Domínio',
    exampleBirthday: 'Exemplo: birthday',
    exampleCompany: 'Exemplo: company',
    exampleDepartment: 'Exemplo: department',
    exampleDomain: 'Exemplo: LDAP://domainad.com',
    exampleEmail: 'Exemplo: mail',
    exampleLDAPQuery:
      'Exemplo: (&(objectCategory=person)(objectClass=user)(!userAccountControl:1.2.840.113556.1.4.803:=2)',
    exampleLeadership: 'Exemplo: manager',
    exampleName: 'Exemplo: name',
    exampleOccupation: 'Exemplo: title',
    examplePhone: 'Exemplo: telephoneNumber',
    examplePhoneExtension: 'Exemplo: Extension',
    exampleUnit: 'Exemplo: physicalDeliveryOfficeName',
    exampleUsername: 'Exemplo: sAMAccountName',
    formTitle: 'Diga-nos os campos correspondentes do 4bee Work+ no seu Active Directory',
    formSubtitle:
      'Digite nos campos abaixo os valores que correspondem aos campos de perfil de usuário no 4bee, que estão presentes no seu AD. Os utilizaremos para sincronizar os dados dos usuários.',
    ldapQuery: 'Filtro da query LDAP',
    leadership: 'Liderança',
    note: 'Obs: os campos que estiverem em branco irão assumir os valores padrão do Active Directory',
    setADFields: 'Adicione aqui os campos correspondentes do seu AD com 4beeWork+',
    subtitle:
      'Você pode determinar os campos do seu Active Directory que aparecerão no 4bee, como empresa, unidade, departamento e cargo.',
    username: 'Usuário',
    userPasswordAuthType: 'Email e senha',
  },
  banner: {
    banners: 'Banners',
    bannerPublished: 'Seu banner foi publicado',
    bannerSubtitle: 'Crie banners que serão exibidos na página inicial da rede.',
    confirmDelete: 'Excluir da galeria',
    countAdded: '{{count}} item adicionado',
    countAdded_plural: '{{count}} itens adicionados',
    countSelectedItem: '{{count}} item selecionado',
    countSelectedItem_plural: '{{count}} itens selecionados',
    createBanner: 'Criar um banner',
    dropImage: 'Arraste a imagem aqui',
    gallery: 'Galeria de imagens',
    gallerySubtitle: 'Selecione uma ou mais imagens da galeria e publique seu banner',
    imageSize: 'Tamanho da imagem 720x240px',
    linkInvalid: 'Link inválido',
    linkModalEdit: 'Adicione um Link',
    lookForFiles: 'Procurar Arquivos',
    pageTitle: 'Adicione um banner a sua galeria',
    previewBanner: 'Preview do banner',
    previewBannerSubtitle:
      'Aqui você pode visualizar como ficará seu banner com as imagens selecionadas.',
    publishBanner: 'Publicar Banner',
    unpublishBanner: 'Despublicar banners',
    publishSelection: 'Publicar selecionados',
    published: 'Publicados',
    relatedLink: 'Adicione um link relacionado ao seu banner',
    select: 'Selecionar',
    unpublished: 'Não publicados',
    messages: {
      bannerCreated: 'Banner adicionado e disponível na galeria: Não publicados',
      bannerCreatedError: 'Não foi possível criar o banner',
      bannerPublished: 'Banner publicado',
      bannerUnpublished: 'Banner despublicado',
      creatingBanner: 'Seu banner está sendo criado',
      emptyBanner: 'Você não possui nenhum banner. Adione fotos da galeria para criar um banner!',
      linkUpdated: 'Link atualizado',
      linkUpdatedError: 'Não foi possível atualizar o link',
    },
    widget: {
      bannerInfo: 'Informações sobre o banner',
      editable:
        'Depois que o banner for publicado, você terá a opção de editar, excluir ou adicionar outro no lugar',
      hide: 'Caso queiram, os usuários poderão ocultá-lo',
      visible: 'Ficará visível para todos da rede',
    },
  },
  cardapio: {
    cardapio: 'Gerenciar Cardápio',
    subtitle:
      'Gerencie o cardápio da rede, cadastre as refeições e mantenha os colaboradores informados.',
    searchPlaceholder: 'Pesquisar por palavra-chave',
    dateFilterPlaceholder: 'Filtrar por data',
    groupBy: 'Agrupar por',
    add: 'Adicionar',
    export: 'Exportar',
    noItemsAdded: 'Nenhum cardápio adicionado',
    dishColumn: 'Prato',
    dateColumn: 'Data',
    mealColumn: 'Refeição',
    actionsColumn: 'Ações',
    edit: 'Editar',
    delete: 'Excluir',
    deleteConfirmTitle: 'Excluir refeição?',
    deleteConfirmDescription: 'Essa ação não pode ser desfeita.',
    specialDish: 'Prato Especial',
    newCardapio: 'Novo Cardápio',
    editCardapio: 'Editar Cardápio',
    dateLabel: 'Data',
    datePlaceholder: 'dd/mm/aaaa',
    mealTypeLabel: 'Refeição',
    mealTypePlaceholder: 'Selecione',
    dishLabel: 'Prato',
    dishPlaceholder: 'Faça uma descrição sobre a refeição',
    dessertLabel: 'Sobremesa (opcional)',
    dessertDescriptionPlaceholder: 'Faça uma descrição sobre a sobremesa',
    specialDishLabel: 'Prato Especial (opcional)',
    close: 'Fechar',
    create: 'Criar',
    save: 'Salvar',
    createSuccess:
      'Cardápio adicionado com sucesso! Uma nova refeição foi adicionada e ela será exibida no widget de cardápio da home.',
    updateSuccess: 'Cardápio atualizado com sucesso!',
    deleteSuccess: 'Cardápio excluído com sucesso!',
    genericError: 'Não foi possível concluir a operação. Tente novamente.',
    paginationTotal: 'Total {{count}} items',
    mealType: {
      breakfast: 'Café da Manhã',
      lunch: 'Almoço',
      afternoonSnack: 'Lanche da Tarde',
      dinner: 'Jantar',
      supper: 'Ceia',
    },
  },
  filtersManagement: {
    added_company: 'Empresas adicionadas',
    added_department: 'Departamentos adicionados',
    added_occupation: 'Cargos adicionados',
    added_unit: 'Unidades adicionadas',
    company_tooltip: 'Adicione quais empresas farão parte da rede',
    department_tooltip: 'Adicione quais departamentos farão parte da rede',
    occupation_tooltip: 'Adicione quais cargos farão parte da rede',
    unit_tooltip: 'Adicione quais unidades farão parte da rede',
    deleteFilter: 'Excluir filtro',
    deleteFilterText:
      '<0>Você realmente quer excluir esse filtro?</0><1>Algumas pessoas podem estar utilizando ele.</1>',
    filtersSettings: 'Gerenciar filtros',
    filterCreated: '"{{filter}}" adicionado com sucesso',
    filterDeleted: '"{{filter}}" removido',
    importantInfo:
      'Essas informações são importantes principalmente para a entrada de novos colaboradores',
    itemPlaceholder: 'Digite o nome da {{item}} que você quer adicionar',
    notEqual: 'Os filtros não podem ser iguais e nem ser um que já existe',
    subtitle:
      'Adicione quais serão as empresas, unidades, departamentos e cargos que farão parte da sua rede',
  },
  network: {
    about: 'Sobre',
    addColor: 'Adicionar cor',
    anotherColor: 'Tema personalizado',
    customization: 'Personalização',
    customizeColor: 'Personalizar cor',
    customizationDescription: 'As alterações feitas aqui, serão aplicadas para todos da sua rede',
    faviconInstruction: 'O favicon deve ser .png e ter no mínimo 16x16 e no máximo 64x64 pixels',
    branding: 'Marca',
    iconsDescription:
      'Para deixar ainda mais com a cara de vocês, adicione um ícone e um logo da empresa',
    invalidFavicon: 'Favicon inválido',
    logoInstruction: 'Utilizar imagens com fundo branco ou transparente',
    networkFunction: 'Funções da rede',
    networkSettings: 'Configurações de rede',
    newFaviconApplied: 'Novo favicon aplicado',
    newLogoApplied: 'Novo logo aplicado',
    newThemeApplied: 'Novo tema aplicado',
    themeColor: 'Cor do tema',
    themeDescription: 'Adicione uma cor que represente sua empresa',
    birthdayPopup: 'Aniversariantes',
    birthdayPopupDescription:
      'Personalize a mensagem exibida aos colaboradores no dia do seu aniversário',
    birthdayPopupEnable: 'Exibir popup de aniversário',
    birthdayPopupEnableDescription:
      'Quando desativado, os aniversariantes não recebem o popup de parabéns',
    birthdayPopupModeDefault: 'Mensagem padrão',
    birthdayPopupModeTemplate: 'Template do sistema',
    birthdayPopupModeCustom: 'Arte personalizada',
    birthdayPopupMessageLabel: 'Mensagem',
    birthdayPopupRestoreDefault: 'Restaurar padrão do sistema',
    birthdayPopupTemplateGallery: 'Escolha um fundo',
    birthdayPopupUploadInstructions:
      'Dimensões recomendadas: 800x600px (proporção 4:3). Formatos aceitos: PNG ou JPG. Tamanho máximo: 2MB.',
    birthdayPopupInvalidArt: 'Arquivo inválido. Use PNG ou JPG de até 2MB.',
    birthdayPopupPreview: 'Pré-visualização',
    birthdayPopupSaved: 'Configuração de aniversariantes salva',
  },
  networkManagement: {
    abuse: 'Denúncia',
    abuseEmail: 'Email de denúncia',
    accountableEmail: 'Email do contato',
    accountableName: 'Nome do contato',
    activeDirectoryIntegration: 'Integração com Active Directory',
    advertisements: 'Banners',
    adminEmail: 'Email do administrador',
    adminName: 'Nome do administrador',
    allowEditEmail: 'Permitir administradores alterar o e-mail dos usuários',
    blockCommenting: 'Usuários podem desativar comentários em seus posts',
    cardapio: 'Gerenciar Cardápio',
    cellphone: 'Celular do contato',
    chat: 'Chat',
    clientName: 'Nome da empresa',
    commentAttachments: 'Anexo nos comentários',
    comments: 'Comentários',
    companies: 'Empresas',
    companyColor: 'Cor da empresa',
    companyLogo: 'Logo da empresa',
    contact: 'Contato',
    contactInfo: 'Contato',
    contactUs: 'Fale conosco',
    contactUsEmail: 'Email do "Fale conosco"',
    contentManagement: 'Gerenciamento de conteúdo',
    customInterface: 'Personalizar interface',
    defineFunctions: 'Defina quais as funções que essa rede deve ter',
    displayBirthdayBlock: 'Exibir widget de aniversários',
    followers: 'Seguidores',
    forbiddenExtensions: 'Extensões de arquivos proibidas',
    hideProfile: 'Permitir usuários esconder dados do perfil',
    hideUserEmail: 'Ocultar e-mail dos usuários',
    likes: 'Curtir',
    loginURL: 'URL do login',
    manageCommentPermission: 'Permissão de comentário',
    manageLikePermission: 'Permissão de curtir',
    markers: 'Marcadores',
    maxActiveUsers: 'Máximo de usuários ativos na rede',
    maxFileSize: 'Tamanho máximo dos arquivos (em MB)',
    maxPhotos: 'Total de fotos permitidas no post',
    mentions: 'Menções',
    networkAdmin:
      'Administrador da rede (vai possuir todas as permissões e será o administrador de todas as configurações da rede e usuários)',
    networkConfig: 'Configurar redes existentes',
    networkFunctions: 'Funções da Rede',
    networkId: 'Id da Rede',
    networkInfo: 'Informações da rede',
    networkLanguage: 'Idioma da rede',
    networkName: 'Nome da rede',
    newNetwork: '+ Nova rede',
    pageEvents: 'Eventos de grupo',
    phone: 'Telefone do contato',
    polls: 'Enquetes',
    postScheduling: 'Agendamento de posts',
    privacy: 'Privacidade',
    profileSettings: 'Configurações do perfil do usuário',
    restrictedPages: 'Grupos restritos',
    searchForCompanies: 'Buscar empresas',
    selectAdmin: 'Escolha um administrador',
    status: 'Estado',
    systemURL: 'URL do sistema',
  },
  permission: {
    changeCover: 'Alterar capa do perfil',
    contentManagement: 'Gerenciar conteúdo',
    createBanner: 'Criar banner',
    createFixedPost: 'Criar post fixo',
    createGroup: 'Criar grupo',
    createNewGroup: 'Criar novo grupo',
    createNews: 'Criar comunicados como usuário',
    createPermissionGroup: 'Criar um grupo de permissão',
    createPostSchedule: 'Criar post agendado',
    createPoll: 'Criar enquetes',
    createPublicPost: 'Criar posts públicos',
    choosePermissionDescription: 'Escolha quais permissões farão parte deste grupo',
    deleteRoleDialog: 'Excluir o grupo de permissão "{{name}}"?',
    detailsDescription: 'Dê um nome ao seu grupo e escolha quais permissões estarão nele',
    errorOnCreate: 'Não foi possível criar o grupo de permissão',
    groupName: 'Nome do grupo',
    manageCardapio: 'Gerenciar Cardápio',
    manageGroupSubtitle:
      'Crie grupos e determine quais permissões alguns usuários podem ter na rede',
    manageNetwork: 'Gerenciar rede',
    manageRoles: 'Gerenciar permissões',
    manageUsers: 'Gerenciar usuários',
    manageGroups: 'Gerenciar grupos',
    manageSkills: 'Gerenciar reconhecimentos',
    membersDescription: 'Escolha quais colaboradores devem fazer parte do grupo',
    permissions: 'Permissões / Restrições',
    permissionsGroups: 'Grupos de permissões',
    pinnedGroups: 'Gerenciar grupos fixados',
    pinnedGroupsModalBody: 'Tem certeza que deseja {{pinned}} este grupo?',
    pinnedGroupsModalTitle: 'Fixar Grupo',
    pinnedGroupsModalPinned: 'fixar',
    pinnedGroupsModalReleased: 'desafixar',
    pinnedGroupsSubtitle: 'Selecione quais grupos serão fixados em sua rede.',
    restrictPublicPost: 'Restringir posts públicos',
    totalMembers: 'Total de membros',
    viewDashboard: 'Visualizar dashboards',
  },
  role: {
    addMembersToRole: 'Adicionar membros ao grupo',
    roleName: 'Grupo <1>{{name}}</1>',
    rolePageDescription: 'Você pode editar os membros e as permissões que fazem parte deste grupo',
    rolePageSampleDescription: 'Você pode editar as permissões que fazem parte deste grupo',
  },
  recognition: {
    recognition: 'Gerenciar reconhecimentos',
    recognitionTitle: 'Configurações Gerais',
    recognitionSubtitle:
      'Adicione quais competências ou valores poderão ser reconhecidos aos colaboradores da sua empresa',
    networkNoSkills: 'A rede ainda não possui competências cadastradas',
    loadingSkills: 'Carregando competências da rede...',
    createRecognition: 'Criar uma competência',
    settingsTitle: 'Configurações de competência',
    enableRecognition: 'Habilitar reconhecimento',
    enableRecognitionDescription:
      'Ative a funcionalidade para que os usuários possam reconhecer uns aos outros usando competências ou valores cadastrados.',
    settingsAnonimousNotify: 'Habilitar reconhecimento anônimo',
    settingsObservation:
      'Ative para ocultar a identidade de quem envia os reconhecimentos. Se desativado, todos na rede poderão ver quem enviou.',
    limitSkillsReached: 'Você atingiu o limite máximo de 8 habilidades permitidas.',
    limitAddSubtitle:
      'Adicione até oito competências ou valores que poderão ser reconhecidos aos colaboradores da sua empresa.',
    addSkills: 'Adicionar Competências',
    addMore: 'Adicionar Mais',
    cancel: 'Cancelar',
    delete: 'Deletar',
    create: 'Criar',
    save: 'Salvar',
    close: 'Fechar',
    continue: 'Continuar',
    add: 'Adicionar',
    newSkill: 'Nova Competência',
    editSkill: 'Editar Competência',
    editSkillTitle: 'Atenção: o novo nome será atualizado em todos os perfis.',
    editSkillDescription:
      'Atenção: Qualquer alteração feita (nome, ícone ou descrição) será atualizada retroativamente nos perfis dos colaboradores que já receberam este reconhecimento. Certifique-se de que a mudança mantém o sentido original.',
    deleteSkill: 'Excluir Reconhecimento?',
    deleteSkillDescription:
      'Excluir reconhecimento: Você realmente quer excluir essa competência ou valor ',
    deleteSkillDescriptionEnd:
      '? Algumas pessoas podem ter recebido esse reconhecimento em seus perfis e este dado será removido.',
    saveEditSkill: 'Salvar atualização da competência',
    confirmeDeleteSkill: 'Confirmar exclusão da competência',
    saveSkills: 'Salvar Competências',
    skillName: 'Nome da Competência',
    newSkills: 'Novas Competências',
    addIcon: 'Adicionar um ícone para sua competência',
    recognitionName: 'Nome do reconhecimento',
    recognitionNamePlaceHolder: 'Nome do reconhecimento',
    recognitionDescription: 'Descrição',
    recognitionDescriptionEnd: 'opcional',
    recognitionDescriptionPlaceHolder: 'Um breve resumo do reconhecimento',
    skillColumn: 'Reconhecimentos',
    createdByColumn: 'Criado por',
    updatedAtColumn: 'Atualizado em',
    actionsColumn: 'Ações',
    limitToCreate: 'Você só pode criar até ',
    limitToCreateEnd: ' competências',
    noRecognitionAdded: 'Nenhuma competência adicionada.',
  },
  shortcuts: {
    addShortcuts: 'Adicionar atalhos',
    addedShortcuts: 'Atalhos adicionados',
    deleteConfirmContent:
      'Ao excluir o atalho, este não estará mais disponível aos usuários da rede',
    deleteConfirmTitle: 'Confirmar exclusão do atalho?',
    deleteIcon: 'Deletar',
    editIcon: 'Editar',
    iconHint: 'Arraste uma imagem ou clique no quadrado para adicionar um ícone.',
    iconHintDescription:
      'Para uma melhor qualidade, o ícone deve ter dimensões no mínimo de 32x32 e o máximo de 64x64 pixels e o tamanho máximo de 5KB.',
    iconHintTask: 'Arraste uma imagem ou clique no quadrado para adicionar um ícone.',
    imageSize: 'Tamanho da imagem 64x64px',
    invalidUrl: 'URL precisa ser completa. (Ex: https://www.exemplo.com)',
    lookForFiles: 'Procurar Arquivos',
    linkRequired: 'Link obrigatório',
    manageShortcuts: 'Gerenciar atalhos',
    modalImgAlt: 'Uma jovem com um notebook sentada sobre livros',
    modalTitle: 'Adicionar Atalho',
    modalSubtitle:
      'Informe a URL do site, o nome e o ícone do atalho. Assim que adicioná-lo ele ficará disponível na aba atalhos.',
    nameLabel: 'Nome do atalho',
    nameRequired: 'Nome obrigatório',
    noShortcut: 'Nenhum atalho encontrado',
    noShortcutDescription:
      'Os atalhos recomendados aparecerão aqui e ficarão visíveis aos usuários',
    saveError: 'Não foi possível salvar o atalho',
    shortcutDescription:
      'Adicione aqui os atalhos recomendados que ficarão fixos para os usuários.',
    shortcutsSubtitle:
      'Você pode adicionar e excluir os atalhos recomendados que deseja disponibilizar para todos os usuários',
    urlLabel: 'URL do atalho',
  },
};

export default adminPt;
